// @ts-strict-ignore
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {TIME_COMPARISON_OPTION_LABELS} from 'common/widgets/date-range-picker/models/presets';
import {BaseDate, DateRangeType, RelativeDate, TimeComparison} from 'common/types/reports/bookmark';
import {Translatable} from 'common/i18n';

import {ComparisonDate} from './types';

export function getRelativeDateFromComparisonDate(comparisonDate: ComparisonDate): RelativeDate {
  const date: BaseDate = comparisonDate.offset ?? comparisonDate.from ?? comparisonDate.to;
  if (DateRange.isRelativeDate(date)) {
    return date;
  }

  return DateRange.convertCalendarDateToRelativeDate(date);
}

export function getComparisonType(comparisonDate?: ComparisonDate) {
  //DateRangeType.EndsOn has a to date. Otherwise, it's StartsOn
  if (comparisonDate?.to) {
    return DateRangeType.EndsOn;
  }
  return DateRangeType.StartsOn;
}

// Why did we use from/to instead of from_date/to_date ?
export function comparisonDateToBookmarkFormat(comparisonDate: ComparisonDate): TimeComparison {
  if (comparisonDate?.offset) {
    return {offset: comparisonDate.offset};
  } else if (comparisonDate?.from) {
    return {from_date: comparisonDate.from};
  } else if (comparisonDate?.to) {
    return {to_date: comparisonDate.to};
  }
  return null;
}

export function comparisonDateFromBookmarkFormat(bookmarkComparisonDate: TimeComparison): ComparisonDate {
  if (`offset` in bookmarkComparisonDate) {
    return {offset: bookmarkComparisonDate.offset};
  } else if (`from_date` in bookmarkComparisonDate) {
    return {from: bookmarkComparisonDate.from_date};
  } else if (`to_date` in bookmarkComparisonDate) {
    return {to: bookmarkComparisonDate.to_date};
  }
  return null;
}

export function getTimeComparisonRangeText(timeComparison: ComparisonDate | TimeComparison): Translatable {
  if (`offset` in timeComparison && timeComparison.offset) {
    return TIME_COMPARISON_OPTION_LABELS[timeComparison.offset.unit];
  }
  const comparisonDate: ComparisonDate =
    `from_date` in timeComparison || `to_date` in timeComparison
      ? comparisonDateFromBookmarkFormat(timeComparison)
      : timeComparison;

  const fromDate = comparisonDate.from;
  const toDate = comparisonDate.to;

  const rolling = DateRange.isRelativeDate(fromDate) || DateRange.isRelativeDate(toDate);
  const rollingLabel = rolling ? ({t}) => ` (${t(`reports.date-range.comparison.rolling-dates`)})` : ``;

  const referenceDate =
    DateRange.convertBaseDateToCalendarDate(toDate) ?? DateRange.convertBaseDateToCalendarDate(fromDate);
  return fromDate
    ? ({t, print}) => t(`reports.date-range.comparison.starting`, {date: referenceDate}) + print(rollingLabel)
    : ({t, print}) => t(`reports.date-range.comparison.ending`, {date: referenceDate}) + print(rollingLabel);
}
